export default "<p>dw-image-zoom-modal works!</p>\n\n<!-- <img [src]=\"src\" [defaultSrc]=\"defaultSrc\" [ngStyle]=\"imageStyle\" [ngClass]=\"class\"> -->";